import { useTranslation } from 'react-i18next'
import { SRModal } from '@sr/ui'
import { Button } from '@shared/storybook'

export const NotifyChangesModal = ({
  open,
  onConfirm,
  onClose,
  isLoading = false,
}) => {
  const { t } = useTranslation()

  if (!open) return null

  return (
    <SRModal
      onClose={onClose}
      title={t('agenda.formModal.notifyModal.title')}
      
      className="max-w-[520px]"
    >
      <div className="flex flex-col gap-6">
        <div className="text-left text-lg font-aeonik">
          {t('agenda.formModal.notifyModal.subtitle')}
        </div>
        <div className="flex justify-end gap-3">
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onConfirm?.(false)}
            disabled={isLoading}
          >
            {t('agenda.formModal.notifyModal.confirmNo')}
          </Button>
          <Button
            size="lg"
            onClick={() => onConfirm?.(true)}
            disabled={isLoading}
          >
            {t('agenda.formModal.notifyModal.confirmYes')}
          </Button>
        </div>
      </div>
    </SRModal>
  )
}

